import React from "react";

import { FormControl } from "lib/index";
import createCompanySettingsView from "modules/settings/createCompanySettingsView";
import { stateSelector, initializeView, updateModel, submit } from "./index";
import Hint from "./ProductsSettingsHint";

const FormContent = ({ company, errors, handleCompanyPropChange }) => (
  <div>
    <FormControl.FormattableTextAreaFormGroup
      {...FormControl.addProps(`model.general_terms`, { errors })}
      value={company.general_terms}
      onChange={handleCompanyPropChange.bind(null, "general_terms")}
      label={I18n.humanAttributeName("company", "general_terms")}
      placeholder={I18n.humanAttributeName("company", "general_terms_placeholder")}
    />

    <FormControl.CheckboxFormGroup
      {...FormControl.addProps(`model.accepts_printed_customer_vouchers`, {
        errors,
      })}
      value={company.accepts_printed_customer_vouchers}
      onChange={handleCompanyPropChange.bind(null, "accepts_printed_customer_vouchers")}
      label={I18n.humanAttributeName("company", "accepts_printed_customer_vouchers")}
      toggle
    />

    {/* <FormControl.CheckboxFormGroup
      {...FormControl.addProps(`model.default_products_enable_frontend_slots_listing`, {errors})}
      value={company.default_products_enable_frontend_slots_listing}
      onChange={handleCompanyPropChange.bind(null, "default_products_enable_frontend_slots_listing")}
      label={I18n.humanAttributeName("company", "default_products_enable_frontend_slots_listing")}
      toggle
      /> */}
  </div>
);

const ProductsSettingsView = createCompanySettingsView({
  stateSelector,
  actions: { initializeView, updateModel, submit },
  title: I18n.t("papp.settings.ProductsSettingsView.title"),
  FormContent,
  Hint,
});

export default ProductsSettingsView;



// WEBPACK FOOTER //
// ./src/modules/settings/ProductsSettingsView/ProductsSettingsView.jsx